import { useEffect } from "react";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import AracFrames from "../../components/jobList/mainFrames/AracFrames";
import YukFrames from "../../components/jobList/mainFrames/YukFrames";
import { handleFrameState, jobListBireBirVeyaBireCokTeklifGonder, jobListCokluTeklifGonder, setJobListActiveActionId } from "../../features/joblist/jobListSlice";
import { showModal } from "../../features/modal/modalSlice";
import getEslestirAll from "../../helper/jobList/getEslestirAll";
import SmallSpinner from "../../components/shared/spinners/SmallSpinner";
import useWindowDimensions from "../../hooks/useWindowSize";

const Container = styled.div`
  .wrapper {
    padding: 0px 30px;
    display: flex;
    flex-direction: column;

    .top-container{
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin-bottom: 30px;

      .btn-outlined{
        border: 1px solid ${({theme}) => theme.mainTextColor};
        padding: 10px 15px;
        color: ${({theme}) => theme.mainTextColor};
        background-color: transparent;
        border-radius: 5px;
        min-width: 220px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-lg);
      }

      .conditional-btn-container{
        display: flex;
        gap: 30px;
      }
    }

    .content-container{
      width: 100%;
      display: flex;
      justify-content: space-between;
      gap: 20px;
    }
  }
`;

const JobList = () => {
  const {
    aracBekleyenYukCheckedItem,
    jobListActiveActionId,
    yukBekleyenAracCheckedItemList,
    gunlukAracList,
    isLoadingJobListCokluTeklifGonder,
    isLoadingJobListBireBirVeyaBireCokTeklifGonder,
  } = useSelector(state => state.jobList)
  const {loadList} = useSelector(state => state.loadList)
  const dispatch = useDispatch()
  const {windowDimensions} = useWindowDimensions()

  useEffect(() => {
    if(aracBekleyenYukCheckedItem && yukBekleyenAracCheckedItemList.length === 1){
      dispatch(setJobListActiveActionId(1))
    }

    if(aracBekleyenYukCheckedItem && yukBekleyenAracCheckedItemList.length > 1){
      dispatch(setJobListActiveActionId(2))
    }

    if(!aracBekleyenYukCheckedItem && yukBekleyenAracCheckedItemList.length === 0){
      dispatch(setJobListActiveActionId(3))
    }
  },[dispatch, yukBekleyenAracCheckedItemList.length, aracBekleyenYukCheckedItem])

  const handleCokluTeklif = () => {
    if(loadList?.length > 0 && gunlukAracList?.length > 0){
      const dataList = getEslestirAll({loadList, gunlukAracList});
      dispatch(jobListCokluTeklifGonder(dataList))
    }
  }

  const handleBireCokTeklifGonder = () => {
    const yukId = aracBekleyenYukCheckedItem.id
    const aracIdList = yukBekleyenAracCheckedItemList.map(item => ({
      gunlukAracId: item.id,
      phoneNumber: item.devamliAraclar.phoneNumber
    }))

    dispatch(jobListBireBirVeyaBireCokTeklifGonder({yukId, surucuList: aracIdList}))
  }

  useEffect(() => {
    if(windowDimensions?.width < 1500){
      dispatch(handleFrameState("aracSide"))
    }else{
      dispatch(handleFrameState("equal"))
    }
  }, [dispatch, windowDimensions])

  if(windowDimensions?.width < 900){
    return <div style={{height: "50vh", display:"flex", alignItems:"center", justifyContent:"center", width: "100%", fontSize:"20px", fontWeight:"600"}}>Ekran boyutunuz bu sayfayı desteklemiyor.</div>
  }

  return (
    <Container>
      <div className="wrapper">
        <div className="top-container">
          <div className="conditional-btn-container">
            {jobListActiveActionId === 1 && (
              <>
                <button className="btn-outlined" onClick={() => dispatch(showModal("jobListDriverAssignment"))}>
                  Yük Ata
                </button>
                <button className="btn-outlined" onClick={() => dispatch(jobListBireBirVeyaBireCokTeklifGonder({yukId: aracBekleyenYukCheckedItem.id, surucuList:[{ gunlukAracId: yukBekleyenAracCheckedItemList[0].id, phoneNumber: yukBekleyenAracCheckedItemList[0].devamliAraclar.phoneNumber}]}))}>
                  {isLoadingJobListBireBirVeyaBireCokTeklifGonder ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : "Sürücüye Seçili Yük İçin Teklif Gönder"}
                </button>
              </>
            )}

            {jobListActiveActionId === 2 && (
              <button className="btn-outlined" onClick={handleBireCokTeklifGonder}>
                {isLoadingJobListBireBirVeyaBireCokTeklifGonder ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : "Teklif Gönder"}
              </button>
            )}

            {jobListActiveActionId === 3 && (
              <button className="btn-outlined" onClick={handleCokluTeklif}>
                {isLoadingJobListCokluTeklifGonder ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : "Sürücülere Eşleşen Yükler İçin Toplu Teklif Gönder"}
              </button>
            )}
          </div>
        </div>

        <div className="content-container">
          <AracFrames/>
          <YukFrames/>
        </div>
      </div>
    </Container>
  );
};

export default JobList;
